































import { Component, Mixins } from 'vue-mixin-decorator';
import { SlotMixin } from '@/mixins/SlotMixin';
import { Prop } from 'vue-property-decorator';
import { Product } from '@/store/types/public/products/Product';
@Component
export default class ProductItem extends Mixins<SlotMixin>(SlotMixin) {
  @Prop() private product!:Product;

  colors:String[] = ['green', 'red', 'blue'];
  text:String[] = ['В наявності', 'Немає в наявності', 'Закінчується'];

  get valueCase () {
    return this.product.value > 5
      ? 0
      : (this.product.value <= 0 ? 1 : 2);
  }
}
